import { requestGooglePlace } from './requestGooglePlace'
import { requestRefreshPlace } from './requestRefreshPlace'
import { updateVehicleGeneration, vehicleGenerationMakes, vehicleGenerationModels } from './vehicleGeneration'

export const dataApi = {
  vehicleGeneration: {
    makes: vehicleGenerationMakes,
    models: vehicleGenerationModels,
    update: updateVehicleGeneration,
  },
  requestGooglePlace,
  requestRefreshPlace,
}
